// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Vendor$ReactHooksTemplate = require("../common/vendor.res.js");

function decodeLogo(json) {
  return Json_decode.optional((function (param) {
                return Json_decode.field("url", Json_decode.string, param);
              }), json);
}

var emptyState = {
  vendor: Vendor$ReactHooksTemplate.make(undefined)
};

function SurveyExpired(props) {
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  React.useEffect((function (param) {
          Js_promise.then_((function (json) {
                  return Promise.resolve(Curry._1(setState, (function (param) {
                                    return {
                                            vendor: Vendor$ReactHooksTemplate.make(decodeLogo(json))
                                          };
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/clients/logo"));
        }), []);
  var logo = Vendor$ReactHooksTemplate.getLogo(match[0].vendor);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        logo !== undefined ? JsxRuntime.jsx("img", {
                                className: "w-64",
                                src: logo
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        JsxRuntime.jsx("div", {
                              children: "Oops! Thank you for trying to participate in the survey. You've already submitted your response or your session has expired.",
                              className: "text-center"
                            })
                      ],
                      className: "flex flex-col items-center"
                    }),
                JsxRuntime.jsx("div", {})
              ],
              className: "flex flex-col items-center h-screen justify-between"
            });
}

var make = SurveyExpired;

exports.decodeLogo = decodeLogo;
exports.emptyState = emptyState;
exports.make = make;
/* emptyState Not a pure module */
